// extracted by mini-css-extract-plugin
module.exports = {"root":"_2tAPw"};